import { render } from "./NNotification.vue?vue&type=template&id=51bf897a&ts=true"
import script from "./NNotification.vue?vue&type=script&lang=ts"
export * from "./NNotification.vue?vue&type=script&lang=ts"

import "./NNotification.vue?vue&type=style&index=0&id=51bf897a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__